import React from 'react';
import { Radar, PenLine, Send } from 'lucide-react';
import { threePillars } from '../mock';

const iconMap = { Radar, PenLine, Send };
const tintClass = {
  orange: { bg: 'bg-orange-100', text: 'text-[#F97316]' },
  indigo: { bg: 'bg-indigo-100', text: 'text-[#4F46E5]' },
  emerald: { bg: 'bg-emerald-100', text: 'text-emerald-600' },
};

const ThreePillars = () => {
  return (
    <section id="how" className="py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-[12px] font-bold uppercase tracking-widest text-[#F97316] mb-3">How it works</p>
          <h2 className="text-[34px] md:text-[46px] font-extrabold text-stone-900 leading-tight">
            Three moves. That's the whole product.
          </h2>
          <p className="mt-4 text-[16px] text-stone-600 leading-relaxed">
            Ambanji is deliberately small on purpose. We stripped local SEO down to the three things that actually change your ranking — and automated all three.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {threePillars.map((p, idx) => {
            const Icon = iconMap[p.icon];
            const tint = tintClass[p.tint];
            return (
              <div key={idx} className="relative bg-white rounded-2xl p-7 border border-stone-200 hover:shadow-xl hover:-translate-y-1 transition-all group">
                <div className="absolute top-6 right-6 text-[13px] font-bold text-stone-300" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                  0{idx + 1}
                </div>
                <div className={`w-14 h-14 rounded-2xl ${tint.bg} flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                  <Icon size={26} className={tint.text} strokeWidth={2} />
                </div>
                <h3 className="text-[20px] font-bold text-stone-900 mb-3">{p.title}</h3>
                <p className="text-[15px] text-stone-600 leading-relaxed">{p.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ThreePillars;
